export default "__VITE_ASSET__leVsOvrK__"